import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lacFormat'
})
export class LacFormatPipe implements PipeTransform {

  transform(value: string, isShowDecimal?: any): any {
    //return Math.pow(value, isNaN(exponent) ? 1 : exponent);
    return this.currencyFilter(value, isShowDecimal);
  }

  currencyFilter(val: string, isShowDecimal: any){
    var Amt = Number(String(val).replace(/\,/g, ""));
        //var Removemi = Math.abs(Amt).toFixed(2);
        var Removemi = Number(Amt).toLocaleString('hi-IN', {
            style: "currency",
            currency: "INR"
        });
        var a = (Removemi).replace("₹", "");
        if(isShowDecimal == 0){
            a = String(a).split(".")[0];
        }
        return String(a).replace("-", "");
  }

}
